<div class="w-full lg:max-w-full lg:flex login-page">
  <div
    class="h-48 lg:h-auto flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden image-login"
    style="background-image: url('assets/img/img_login.png'); width: 60%"
    alt="image"
  ></div>
  <div
    class="border-gray-400 lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r pt-6 w-full card-login"
  >
    <div class="flex justify-between mb-10">
      <div
        class="logo-icon"
        style="background-image: url('assets/img/logo_unchk.png')"
      ></div>
      <div
        class="logo-icon"
        style="background-image: url('assets/img/logo_master_card.png')"
      ></div>
    </div>

    <div class="">
      <app-card-form [title]="titleCard">
        <!-- <div class=""> -->
        <div class="inline-flex items-center justify-center w-full">
          <hr class="w-full h-px bg-gray-300 border-0 dark:bg-gray-700" />
          <span
            class="absolute px-3 font-medium text-gray-900 bg-white dark:text-white dark:bg-gray-900"
            >Veuillez fournir votre email pour recuperer votre mot de
            passe.</span
          >
        </div>
        <!-- </div> -->

        <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">

          <form [formGroup]="fromForget">
            <div>
              <label
                for="email"
                class="block text-sm font-medium leading-6 text-gray-500"
                >Adresse Email *</label
              >
              <div class="mt-2">
                <input
                  id="email"
                  formControlName="email"
                  type="email"
                  autocomplete="email"
                  required
                  placeholder="nom@force.sn"
                  class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <br />
            <br />
            <br />

            <div>
              <button
                type="submit"
                class="flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 btn-login"
                (click)="onSubmti()"
              >
                <!-- <a
                  [routerLink]="['/auth/after-account']"
                  class="flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 btn-login"
                >
                  Changer le mot de passe
                </a> -->
                Changer le mot de passe
              </button>
            </div>
          </form>
         
          
          <p class="mt-10 text-center text-sm text-gray-500">
            <!-- <span>Dejà membre de Force-N ?</span> -->

            <a
              href="/fode-connexion'"
              class="font-semibold leading-6 text-blue-600 hover:text-blue-500 ml-2 float-right"
              >Se connecter</a
            >
          </p>

          <div class="mt-5">
            <!-- <a
                  href="#"
                  class="font-semibold leading-6 text-blue-600 hover:text-blue-500 text-sm float-right"
                  >Mot passe oublié ?</a
                > -->
          </div>
        </div>
      </app-card-form>
    </div>

    <div class="flex justify-center mt-8">
      <div
        class="logo-icon"
        style="background-image: url('assets/img/logo_force_n.png')"
      ></div>
    </div>
  </div>
</div>
